"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDeviceDetect = require("react-device-detect");

var _classnames = _interopRequireDefault(require("classnames"));

var _options_list = _interopRequireDefault(require("./options_list"));

require("../../css/shared/contextual_menu.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContextualMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContextualMenu, _React$Component);

  function ContextualMenu(props) {
    var _this;

    _classCallCheck(this, ContextualMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContextualMenu).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClick", function (event, option) {
      var onClick = _this.props.onClick;

      if (onClick) {
        _this.handleOptionSelect(event, option);

        _this.setState({
          highlightedIndex: undefined
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseDown", function (event, option) {
      var onMouseDown = _this.props.onMouseDown;

      if (onMouseDown) {
        _this.handleOptionSelect(event, option);

        _this.setState({
          highlightedIndex: undefined
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMouseMove", function (event, option) {
      var highlightedIndex = _this.state.highlightedIndex;
      var options = _this.props.options;
      event.preventDefault();

      if (option.disabled || _reactDeviceDetect.isMobile) {
        return;
      }

      var index = options.findIndex(function (opt) {
        return opt.value === option.value;
      });

      if (index !== highlightedIndex) {
        _this.setState({
          highlightedIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event, option) {
      var options = _this.props.options;
      var highlightedIndex = _this.state.highlightedIndex;

      switch (event.keyCode) {
        case 13: // ENTER

        case 32:
          // SPACE
          _this.handleOptionSelect(event, option);

          _this.setState({
            highlightedIndex: undefined
          });

          break;

        case 38:
          // UP
          event.preventDefault();

          if (highlightedIndex > 0 || highlightedIndex === undefined) {
            _this.nextOptionSelection(38);
          }

          break;

        case 40:
          // DOWN
          event.preventDefault();

          if (highlightedIndex < options.length - 1 || highlightedIndex === undefined) {
            _this.nextOptionSelection(40);
          }

          break;

        default:
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOptionSelect", function (event, option) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onMouseDown = _this$props.onMouseDown;
      event.preventDefault();

      if (option.disabled) {
        return;
      }

      switch (event.type) {
        case 'click':
          onClick(event, option);
          break;

        case 'mousedown':
          onMouseDown(event, option);
          break;

        case 'keydown':
          if (onClick) {
            onClick(event, option);
          } else if (onMouseDown) {
            onMouseDown(event, option);
          }

          break;

        default:
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      if (_this.highlightedOptionNode) {
        _this.highlightedOptionNode.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nextOptionSelection", function (keyCode) {
      var options = _this.props.options;
      var highlightedIndex = _this.state.highlightedIndex;
      var nextIndex = highlightedIndex;

      if (nextIndex === undefined) {
        nextIndex = keyCode === 40 ? -1 : options.length;
      }

      nextIndex = keyCode === 40 ? nextIndex + 1 : nextIndex - 1;

      while (nextIndex >= 0 && nextIndex <= options.length - 1) {
        if (options[nextIndex].disabled === true) {
          nextIndex = keyCode === 40 ? nextIndex + 1 : nextIndex - 1;
        } else {
          break;
        }
      }

      _this.setState({
        highlightedIndex: nextIndex
      });
    });

    var _this$props2 = _this.props,
        _options = _this$props2.options,
        value = _this$props2.value;

    var _index;

    if (value) {
      _index = _options.findIndex(function (opt) {
        return opt.value === value;
      });
    }

    _this.state = {
      highlightedIndex: _index >= 0 ? _index : undefined
    };
    return _this;
  }

  _createClass(ContextualMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (_reactDeviceDetect.isMobile) {
        return;
      }

      this.handleFocus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var highlightedIndex = this.state.highlightedIndex;

      var _this$props3 = this.props,
          className = _this$props3.className,
          value = _this$props3.value,
          props = _objectWithoutProperties(_this$props3, ["className", "value"]);

      var menuClassName = (0, _classnames.default)(_defineProperty({
        'vn-contextual-menu': true
      }, className, className !== undefined));
      return _react.default.createElement("div", {
        className: menuClassName
      }, _react.default.createElement(_options_list.default, _extends({}, props, {
        highlightedIndex: highlightedIndex,
        highlightedRef: function highlightedRef(el) {
          _this2.highlightedOptionNode = el;
        },
        onClick: this.onClick,
        onMouseDown: this.onMouseDown,
        onMouseMove: this.onMouseMove,
        onKeyDown: this.onKeyDown,
        value: [value]
      })));
    }
  }]);

  return ContextualMenu;
}(_react.default.Component);

ContextualMenu.propTypes = {
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseMove: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    disabled: _propTypes.default.bool,
    icon: _propTypes.default.string,
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
  })).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
ContextualMenu.defaultProps = {
  className: '',
  onClick: undefined,
  onKeyDown: undefined,
  onMouseDown: undefined,
  onMouseMove: undefined,
  value: undefined
};
ContextualMenu.displayName = 'ContextualMenu';
var _default = ContextualMenu;
exports.default = _default;